module.exports = __webpack_public_path__ + "media/dashboard/assets/images/berrysupport-onboard-complete-9389e0a31a5474a8e69159487c088347.svg";